import { useContext } from 'react';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';

import Tipper from 'components/Tipper';

import { createCookie, getCookie } from 'lib/utilities/Cookies';
import { COOKIE_TOOLTIP_CLOSE } from './Constants';
import { TootipSearchContent, TootipSearchLabel } from './components';

const TootipSearch = () => {
	const { naturalLanguage }: any = useContext(CruiseSearchContext);
	const { setInstance } = naturalLanguage || {};

	const tippyProps = () => {
		const conf = {
			interactive: true,
			animation: 'scale',
			offset: [0, 13],
			maxWidth: 330,
			trigger: 'manual',
			delay: [100, 100],
			showOnCreate: !getCookie(COOKIE_TOOLTIP_CLOSE),
			hideOnClick: false,
			onCreate(instance) {
				setInstance(instance);
			},
			onHide() {
				createCookie(COOKIE_TOOLTIP_CLOSE, true, {}, true);
			},
			zIndex: 1,
			id: 'Tooltip-NL-Search',
		};
		return conf;
	};

	return (
		<Tipper placement="bottom_end" content={<TootipSearchContent />} configuration={tippyProps()} type="tooltip" theme="WithArrow" disabled={false}>
			<TootipSearchLabel />
		</Tipper>
	);
};

export default TootipSearch;
